
(function () {
    'use strict';

    angular.module('thankview.global')
        .directive('compileButtons', ['$compile', function ($compile) {
            return {
                scope: true,
                link: function (scope, element, attrs) {
                    let elmnt;

                    attrs.$observe('buttons', function (markup) {
                        if (markup === '') {
                            return;
                        }
                        console.log(markup);
                        if (angular.isDefined(markup)) {
                            // compile the provided template against the current scope
                            elmnt = $compile(markup)(scope);

                            element.html(''); // dummy "clear"

                            element.append(elmnt);
                        }
                    });
                },
            };
        }]);
}());
